export enum RuleType {
  MustHaveAll = 1,
  MustHaveAnyOne = 2,
  UnlimitedTalkTime = 3,
  LTETopUp = 4
}